import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RemoteMCPConnection, RemoteMCPServer } from '@/api/remoteMCP'

export interface RemoteMCPState {
  servers: RemoteMCPServer[]
  connections: RemoteMCPConnection[]
  loading: boolean
  connectingServerId: number | null
  error: string | null
}

const initialState: RemoteMCPState = {
  servers: [],
  connections: [],
  loading: false,
  connectingServerId: null,
  error: null,
}

const remoteMCPSlice = createSlice({
  name: 'remoteMCP',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
      state.loading = false
    },
    setServers: (state, action: PayloadAction<RemoteMCPServer[]>) => {
      state.servers = action.payload
      state.loading = false
      state.error = null
    },
    setConnections: (state, action: PayloadAction<RemoteMCPConnection[]>) => {
      state.connections = action.payload
      state.loading = false
      state.error = null
    },
    setConnectingServerId: (state, action: PayloadAction<number | null>) => {
      state.connectingServerId = action.payload
    },
    removeConnection: (state, action: PayloadAction<number>) => {
      state.connections = state.connections.filter((c) => c.id !== action.payload)
    },
  },
})

export const {
  setLoading,
  setError,
  setServers,
  setConnections,
  setConnectingServerId,
  removeConnection,
} = remoteMCPSlice.actions

export default remoteMCPSlice.reducer

export const selectRemoteMCPServers = (state: { remoteMCP: RemoteMCPState }) =>
  state.remoteMCP.servers
export const selectRemoteMCPConnections = (state: { remoteMCP: RemoteMCPState }) =>
  state.remoteMCP.connections
export const selectRemoteMCPLoading = (state: { remoteMCP: RemoteMCPState }) =>
  state.remoteMCP.loading
export const selectRemoteMCPError = (state: { remoteMCP: RemoteMCPState }) =>
  state.remoteMCP.error
export const selectConnectingServerId = (state: { remoteMCP: RemoteMCPState }) =>
  state.remoteMCP.connectingServerId
